import ProducerSelector from "@main/producers/components/ProducerSelector";
import { Producer } from "@main/producers/models/Producer";
import projectWidgets from "@main/projectWidgets";

const filterUIConfig = {
  uiScheme: {
    "ui:classNames": "filters-container",
    search: {
      "ui:options": {
        placeholder: "Referencia / cliente",
      },
    },
    start_date: {
      "ui:options": {
        placeholder: "Desde",
        title: "Desde",
      },
    },
    end_date: {
      "ui:options": {
        placeholder: "Hasta",
        title: "Hasta",
      },
    },
    order_status: {
      "ui:placeholder": "status",
      "ui:widget": "type-selector",
      "ui:options": {
        configPath: "types.orders.status",
      },
    },
    producer_id: {
      "ui:placeholder": "Productor",
      "ui:widget": ProducerSelector
    }
  },
  widgets: { ...projectWidgets },
};
const getFilterUIConfig: any = (type: string) => {
  return filterUIConfig;
};
export default getFilterUIConfig;
